import { HybridHelper } from '../../upgrade/upgradeHelper.ts';
// Angular services
import { SearchService } from '../../../shared/services/helpers/search.service.ts';
import { MessageService } from '../../../shared/services/helpers/message-service/message.service';
import { AppointmentServiceProvider } from '../../../shared/services/tasks/appointment.service';
import { ValidationProvider } from '../../../shared/services/helpers/validation.service';
import { TimeServiceProvider } from '../../../shared/services/helpers/time-service/time.service';
import { ClientsDataServiceProvider } from '../../../shared/services/client/clients.data.service';
import { TimeConverterProvider } from '../../../shared/services/helpers/time-converter';
import { ClientServiceProvider } from '../../../shared/services/client/client.service';
import { ExtraShootServiceProvider } from '../../../shared/services/tasks/extra-shoot.service';
import { ImageConverterProvider } from '../../../shared/services/files/image-converter.service';
import { CalendarEventsDataProvider } from '../../../shared/services/calendar/calendar-events.data.service';
import { RandomStringGeneratorProvider } from '../../../shared/services/helpers/random-string-generator';
import { IntegrationsDataProvider } from '../../../shared/services/integrations/integrations.data.service';
import { TemplatesDataProvider } from '../../../shared/services/data-services/templates-data-service/templates.data.service';
import { PaymentsServiceProvider } from '../../../shared/services/payments/payments-service/payments.service';
import { InvoicesDataProvider } from '../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { WorkflowDataProvider } from '../../../shared/services/workflow/workflow.data.service';
import { WorkflowProvider } from '../../../shared/services/workflow/workflow-service/workflow.service';
import { WorkflowDragNDropProvider } from '../../../shared/services/workflow/workflow-drag-n-drop';
import { EmailServiceProvider } from '../../../shared/services/email/email-service/email.service';
import { MailsDataProvider } from '../../../shared/services/email/mails.data.service';
import { UtilsServiceProvider } from '../../../shared/services/utils/utils-service';
import { NotesDataServiceProvider } from '../../../shared/services/notes/notes.data.service';
import { FileUploadDataProvider } from '../../../shared/services/files/file-upload.data.service';
import { FileUploadServiceProvider } from '../../../shared/services/files/file-upload-service/file-upload.service';
import { QuestionnairesDataProvider } from '../../../shared/services/questionnarie/questionnaires.data.service';
import { ContractsDataProvider } from '../../../shared/services/contract/contracts.data.service';
import { EmailSettingsDataService } from '../../../shared/services/settings/email-settings.data.service';
import { AccountDataServiceProvider } from '../../../shared/services/user/account.data.service';
import { StringModifierServiceProvider } from '../../../shared/services/helpers/string-modifier-service/stringModifier.service';
import { StripeDataProvider } from '../../../shared/services/subscription/stripe.data.service';
import { AccountServiceProvider } from '../../../shared/services/user/account.service';
import { UserServiceProvider } from '../../../shared/services/user/user.service';
import { StripeServiceProvider } from '../../../shared/services/subscription/stripe-service';
import { PromoCodeDataProvider } from '../../../shared/services/subscription/promo-code.data.service';
import { PromoCodeProvider } from '../../../shared/services/subscription/promo-code.service';
import { SettingsProvider } from '../../../shared/services/settings/settings';
import { AuthTokensService } from '../../modern/auth-tokens.service';
import { LeadsDataServiceProvider } from '../../../shared/services/lead/leads.data.service';
import { JobsDataServiceProvider } from '../../../shared/services/job/jobs.data.service';
import { PaymentsDataServiceProvider } from '../../../shared/services/payments/payments-data-service/payments.data.service';
import { QuotesDataProvider } from '../../../shared/services/quote/quotes-data-service/quotes.data.service';
import { JobTypesDataProvider } from '../../../shared/services/job/job-types.data.service';
import { InvoiceServiceProvider } from '../../../shared/services/invoice/invoice-service/invoice.service';
import { ContractsServiceProvider } from '../../../shared/services/contract/contracts-service/contracts.service';
import { QuestionnairesServiceProvider } from '../../../shared/services/questionnarie/questionnaires-service/questionnaires.service';
import { ProductPackagesServiceProvider } from '../../../mobile/src/providers/product-packages-service/product-packages.data.service';
import { FileDownloadDataServiceProvider } from '../../../shared/services/files/file-download-service/file-download.data.service';
import { PaymentSchedulesDataProvider } from '../../../shared/services/payments/payments-schedules-data-service/payments-schedules.data.service';
import { JobServiceProvider } from '../../../shared/services/job/job.service';
import { LeadServiceProvider } from '../../../shared/services/lead/lead.service';
import { AmbassadorService } from '../../modern/services/admin/ambassadors/ambassador.service';
import { AdminUsersDataService } from '../../modern/services/admin/users/admin-users.data.service';
import { AdminReportsDataService } from '../../modern/services/admin/users/admin-reports.data.service';
import { PaginationService } from '../../../shared/services/pagination/pagination.service';
import { CalendarServiceProvider } from '../../../shared/services/calendar/calendar.service';
import { CalendarIntegrationProvider } from '../../../shared/services/calendar-integration/calendar-integration.service';
import { CompanySettingsServiceProvider } from '../../../shared/services/settings/company-settings';
import { SubscriptionServiceProvider } from '../../../shared/services/subscription/subscription.service';
import { DashboardDataServiceProvider } from '../../../shared/services/dashboard/dashboard.data.service';
import { ProductPackagesDataServiceProvider } from '../../../shared/services/settings/product-packages.data.service';
import { ProfileUpdateDataServiceProvider } from '../../modern/services/profile/profile-update.data.service';
import { ShootProofDataProvider } from '../../../shared/services/integrations/shootProof/shootProof.data.service';

const moduleName = 'main';

HybridHelper.downgradeProvider(moduleName, 'searchService', SearchService)
	.downgradeProvider(moduleName, 'messageService', MessageService)
	.downgradeProvider(
		moduleName,
		'shootProofDataService',
		ShootProofDataProvider
	)
	.downgradeProvider(
		moduleName,
		'appointmentService',
		AppointmentServiceProvider
	)
	.downgradeProvider(moduleName, 'validationService', ValidationProvider)
	.downgradeProvider(moduleName, 'timeService', TimeServiceProvider)
	.downgradeProvider(moduleName, 'calendarService', CalendarServiceProvider)
	.downgradeProvider(
		moduleName,
		'clientsDataService',
		ClientsDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'calendarIntegrationService',
		CalendarIntegrationProvider
	)
	.downgradeProvider(moduleName, 'timeConverter', TimeConverterProvider)
	.downgradeProvider(moduleName, 'calendarService', CalendarServiceProvider)
	.downgradeProvider(moduleName, 'clientService', ClientServiceProvider)
	.downgradeProvider(moduleName, 'extraShootService', ExtraShootServiceProvider)
	.downgradeProvider(moduleName, 'imageConverter', ImageConverterProvider)
	.downgradeProvider(
		moduleName,
		'calendarEventsDataService',
		CalendarEventsDataProvider
	)
	.downgradeProvider(
		moduleName,
		'stringModifierService',
		StringModifierServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'randomStringGenerator',
		RandomStringGeneratorProvider
	)
	.downgradeProvider(
		moduleName,
		'integrationsDataService',
		IntegrationsDataProvider
	)
	.downgradeProvider(
		moduleName,
		'templateRequestsService',
		TemplatesDataProvider
	)
	.downgradeProvider(moduleName, 'paymentsService', PaymentsServiceProvider)
	.downgradeProvider(moduleName, 'invoicesDataService', InvoicesDataProvider)
	.downgradeProvider(moduleName, 'workflowDataService', WorkflowDataProvider)
	.downgradeProvider(moduleName, 'newWorkflowService', WorkflowProvider)
	.downgradeProvider(
		moduleName,
		'newWorkflowDragNDropService',
		WorkflowDragNDropProvider
	)
	.downgradeProvider(moduleName, 'emailService', EmailServiceProvider)
	.downgradeProvider(moduleName, 'mailsDataService', MailsDataProvider)
	.downgradeProvider(moduleName, 'utilsService', UtilsServiceProvider)
	.downgradeProvider(moduleName, 'notesDataService', NotesDataServiceProvider)
	.downgradeProvider(
		moduleName,
		'fileUploadDataService',
		FileUploadDataProvider
	)
	.downgradeProvider(
		moduleName,
		'newfileUploadService',
		FileUploadServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'questionnairesDataService',
		QuestionnairesDataProvider
	)
	.downgradeProvider(moduleName, 'contractsDataService', ContractsDataProvider)
	.downgradeProvider(
		moduleName,
		'emailSettingsDataService',
		EmailSettingsDataService
	)
	.downgradeProvider(
		moduleName,
		'accountDataService',
		AccountDataServiceProvider
	)
	.downgradeProvider(moduleName, 'stripeDataService', StripeDataProvider)
	.downgradeProvider(moduleName, 'accountService', AccountServiceProvider)
	.downgradeProvider(moduleName, 'userService', UserServiceProvider)
	.downgradeProvider(moduleName, 'stripeService', StripeServiceProvider)
	.downgradeProvider(moduleName, 'promoCodesDataService', PromoCodeDataProvider)
	.downgradeProvider(moduleName, 'promoCodeService', PromoCodeProvider)
	.downgradeProvider(moduleName, 'settingsService', SettingsProvider)
	.downgradeProvider(moduleName, 'authTokensService', AuthTokensService)
	.downgradeProvider(moduleName, 'leadDataService', LeadsDataServiceProvider)
	.downgradeProvider(moduleName, 'newJobsDataService', JobsDataServiceProvider)
	.downgradeProvider(
		moduleName,
		'paymentsDataService',
		PaymentsDataServiceProvider
	)
	.downgradeProvider(moduleName, 'quotesDataService', QuotesDataProvider)
	.downgradeProvider(moduleName, 'jobTypesDataService', JobTypesDataProvider)
	.downgradeProvider(moduleName, 'invoiceService', InvoiceServiceProvider)
	.downgradeProvider(moduleName, 'contractService', ContractsServiceProvider)
	.downgradeProvider(
		moduleName,
		'productPackageService',
		ProductPackagesServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'questionnairesService',
		QuestionnairesServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'fileDownloadDataService',
		FileDownloadDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'paymentSchedulesDataService',
		PaymentSchedulesDataProvider
	)
	.downgradeProvider(moduleName, 'jobService', JobServiceProvider)
	.downgradeProvider(moduleName, 'leadService', LeadServiceProvider)
	.downgradeProvider(moduleName, 'ambassadorService', AmbassadorService)
	.downgradeProvider(moduleName, 'adminUsersDataService', AdminUsersDataService)
	.downgradeProvider(
		moduleName,
		'adminReportsDataService',
		AdminReportsDataService
	)
	.downgradeProvider(moduleName, 'paginationService', PaginationService)
	.downgradeProvider(
		moduleName,
		'companySettingsService',
		CompanySettingsServiceProvider
	)
	.downgradeProvider(moduleName, 'paginationService', PaginationService)
	.downgradeProvider(
		moduleName,
		'dashboardDataService',
		DashboardDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'productPackagesDataService',
		ProductPackagesDataServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'subscriptionService',
		SubscriptionServiceProvider
	)
	.downgradeProvider(
		moduleName,
		'profileUpdateService',
		ProfileUpdateDataServiceProvider
	);



// WEBPACK FOOTER //
// ./web/js/services/downgradedServices.js